import "./assets/styles/global.css";
import "./assets/styles/generic.css";
import Routes from "./Routes.js";
import FullPageLoaderProvider from "./contexts/fullPageLoader";
import PaymentPageProvider from "./contexts/PaymentPageLoader";
import InformationPopUpProvider from "./contexts/informationPopUp";
import ConfirmationPopUp from "./contexts/confirmationPopUp";
// import UnavailabilityInfo from "./components/Unavailable/Unavailable.js";

function App() {
  return (
    <FullPageLoaderProvider>
      <PaymentPageProvider>
        <InformationPopUpProvider>
          <ConfirmationPopUp>
            <Routes />
          </ConfirmationPopUp>
        </InformationPopUpProvider>
      </PaymentPageProvider>
    </FullPageLoaderProvider>
  );
}

export default App;
